import { render, staticRenderFns } from "./ViewWidget.vue?vue&type=template&id=7b706f77"
import script from "./ViewWidget.vue?vue&type=script&lang=js"
export * from "./ViewWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports